<template>
  <div id="vrSensorData">
    <!-- <p style="color:white">Sensor Data (sensorid={{ $route.query.sensorid }})</p> -->
    <div class="chart-div">
      <div class="chart-title">{{ info.title }}</div>
      <div class="chart-content" id="vrSensorChartDiv"></div>
    </div>
  </div>
</template>
<script>
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {},
  data() {
    return {
      info: {
        title: "",
        chartPolling: null,
        chartData: [
          {
            x: [],
            y: [],
            type: "scatter",
            mode: "lines+markers",
            line: {
              width: 2,
              color: "#01FFFF",
            },
            name: "trace0",
          },
          {
            x: [],
            y: [],
            type: "scatter",
            mode: "lines+markers",
            line: {
              width: 2,
              color: "#ff00ff",
            },
            name: "trace1",
          },
          {
            x: [],
            y: [],
            type: "scatter",
            mode: "lines+markers",
            line: {
              width: 2,
              color: "#ff0039",
            },
            name: "temp",
            yaxis: "y2",
          },
        ],
      },
    };
  },
  beforeDestroy() {
    this.destroyChartPolling();
  },
  destroyed() {
    this.destroyChartPolling();
  },
  created() {
    this.setChartPolling();
  },
  methods: {
    setChartPolling() {
      this.getChartData();
      this.info.chartPolling = setInterval(() => {
        this.getChartData();
      }, 30000);
    },
    destroyChartPolling() {
      if (this.info.chartPolling != null) {
        clearInterval(this.info.chartPolling);
        this.info.chartPolling = null;
      }
    },
    getChartData() {
      if (this.$route.query.sensorid) {
        var reqBody = {
          sensor_idx: this.$route.query.sensorid,
        };
        this.$http
          .post("/vrPopup/getSensorData", reqBody)
          .then((res) => {
            if (res.data.resultyn === "Y") {
              let data = res.data.data;
              console.log(data);
              let keys = Object.keys(data);
              for (let i = 0; i < keys.length; i++) {
                let item = data[Object.keys(data)[i]];

                if (item !== null && item !== undefined) {
                  this.info.title = item.sensorname;
                  this.info.chartData[0].x.push(item.collecttime);
                  this.info.chartData[0].y.push(item.sensorval1);
                  this.info.chartData[1].x.push(item.collecttime);
                  this.info.chartData[1].y.push(item.sensorval2);
                  this.info.chartData[2].x.push(item.collecttime);
                  this.info.chartData[2].y.push(item.temp);
                }
                this.drawDoubleYAxisLineChart();
              }
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.destroyChartPolling();
      }
    },
    drawDoubleYAxisLineChart() {
      var layout = chartUtil.setDefaultTimeAndDoubleYAxisAutoSizeLayout();

      layout.margin = {
        l: 50,
        r: 50,
        t: 15,
        b: 50,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot("vrSensorChartDiv", this.info.chartData, layout);
    },
  },
};
</script>

<style lang="scss">
#vrSensorData {
  width: 100%;
  height: 100%;

  .chart-div {
    width: 100%;
    height: 100%;
    background-color: #0e131f;
    border: 3px groove #7b7baf;
    padding: 10px;

    .chart-title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      color: #c5c8d0;
      font-size: 15px;
      text-align: center;
    }
    .chart-content {
      height: calc(100% - 30px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vrpopup/VRSensorData.vue